module.exports = __webpack_public_path__ + "static/img/icon-card-2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-card-2.png
// module id = 567
// module chunks = 0